<template>
    <nav class="carzRangeSearchPagination">
        <button type="button"
                class="carzRangeSearchPagination__prev"
                @click="prevPage"
                :disabled="isPrevDisabled"
        >
            <slot name="prevContent">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" fill="currentColor"><path d="M231.293 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L70.393 256 251.092 74.87c4.686-4.686 4.686-12.284 0-16.971L231.293 38.1c-4.686-4.686-12.284-4.686-16.971 0L4.908 247.515c-4.686 4.686-4.686 12.284 0 16.971L214.322 473.9c4.687 4.686 12.285 4.686 16.971-.001z"/></svg>
                <span class="sr-only">Previous</span>
            </slot>
        </button>
        <button type="button"
                class="carzRangeSearchPagination__next"
                @click="nextPage"
                :disabled="isNextDisabled"
        >
            <slot name="nextContent">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" fill="currentColor"><path d="M24.707 38.101L4.908 57.899c-4.686 4.686-4.686 12.284 0 16.971L185.607 256 4.908 437.13c-4.686 4.686-4.686 12.284 0 16.971L24.707 473.9c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L41.678 38.101c-4.687-4.687-12.285-4.687-16.971 0z"/></svg>
                <span class="sr-only">Next</span>
            </slot>
        </button>

        <div class="carzRangeSearchPagination__context">
            {{ pagesContext }}
        </div>
    </nav>
</template>

<script>
export default {
    props: {
        page: {
            type: Number
        },
        perPage: {
            type: Number
        },
        totalPages: {
            type: Number
        },
        totalResults: {
            type: Number
        }
    },
    methods: {
        prevPage() {
            if (this.page <= 1) {
                return;
            }

            return this.$emit('prev');
        },
        nextPage() {
            if (this.page >= this.totalPages) {
                return;
            }

            return this.$emit('next');
        },
    },
    computed: {
        pagesContext() {
            if (this.totalPages <= 0) {
                return 'Page 1 of 1';
            }

            return `Page ${this.page} of ${this.totalPages}`
        },
        isPrevDisabled() {
            return this.page <= 1;
        },
        isNextDisabled() {
            return this.page >= this.totalPages;
        }
    }
}
</script>
